import script from "./CardFragmentView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardFragmentView.vue?vue&type=script&setup=true&lang=js"

import "./CardFragmentView.vue?vue&type=style&index=0&id=beed88ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beed88ca"]])

export default __exports__